import { useCarlitoHubAccessToken } from '@carlito/hub-react';
import { useEffect } from 'react';
import { getConciergeConfig } from '../config';
import { getDeviceId, retrievePwaShareData, savePwaShareData } from '../infrastructure/pwa-share';

interface UseGetWebManifestUrlParams {
  isIos: boolean;
  /**
   * This will be the app view which will be opened
   * whne the PWA is opened from the homescreen.
   * Needs to be a relative path like '/app/home'
   */
  startAppViewPath: string;
}

interface PwaShareData {
  jwt: string;
}

/**
 * Returns the current URL to
 * the web manifest, which is generated
 * dynamically on the fly, so that
 * iOS users don't have to double
 * login. Ugh.
 */
export function useGetWebManifestUrl({ isIos, startAppViewPath }: UseGetWebManifestUrlParams) {
  // useLayoutEffect(() => {
  //   // Remove existing manifest reference in HTML document
  //   // if there's any present
  //   const foundManifestEl = document.querySelector('link[rel="manifest"]');
  //   if (foundManifestEl) {
  //     foundManifestEl.remove();
  //   }
  // }, []);

  const isIosStandalone = isIos && (window.navigator as any).standalone;

  const { accessToken } = useCarlitoHubAccessToken();

  const shouldSyncPwaData = !isIosStandalone;

  useEffect(() => {
    if (shouldSyncPwaData && accessToken) {
      const data = {
        jwt: accessToken,
      };

      savePwaShareData(data);
    }
  }, [accessToken, shouldSyncPwaData]);

  let manifestUrl = `${
    getConciergeConfig().apiUri
  }/hotels/manifest.webmanifest/?startAppViewPath=${encodeURIComponent(startAppViewPath)}`;

  if (shouldSyncPwaData) {
    // Append data to manifest URL only on iOS and only
    // if not in standalone mode
    manifestUrl = `${manifestUrl}&startUrlData=${encodeURIComponent(
      JSON.stringify({ device_id: getDeviceId() })
    )}`;
  }

  return manifestUrl;
}

interface StartUrlData {
  device_id: string;
}

function getStartUrlData(): StartUrlData | null {
  const urlParams = new URLSearchParams(window.location.search);
  const startUrlData = urlParams.get('startUrlData');

  return startUrlData ? JSON.parse(decodeURIComponent(startUrlData)) : null;
}

const initialStartUrlData = getStartUrlData();

/**
 * Retrieves any shared PWA
 * data to initialize the app state.
 * This is needed to share data between
 * Safari <> PWA
 */
export async function getPwaShareData(): Promise<PwaShareData | null> {
  if (!initialStartUrlData?.device_id) return null;
  return retrievePwaShareData<PwaShareData>(initialStartUrlData.device_id);
}
